module.exports = __webpack_public_path__ + "static/img/img14.b2d8466.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img14.png
// module id = dm2W
// module chunks = 1